import _ from 'lodash';
import moment from 'moment';
import { TDirectMessage } from '../types/direct-chat';
import { TMessage } from '../types/rooms';
import { LANG_EN_SLUG, LANG_SK_SLUG, TLangSlug } from '../types/app';

export const getDateFormat = (): string =>
  moment.locale() === LANG_EN_SLUG ? 'Do MMM YYYY ' : 'D. MMMM YYYY';

export const getShortDateFormat = (): string =>
  moment.locale() === LANG_EN_SLUG ? 'Do MMM YYYY ' : 'D. MMM YYYY';

export const getTimeFormat = (withSeconds: boolean = true): string =>
  withSeconds ? 'HH:mm:ss' : 'HH:mm';

export const getDateTimeFormat = (): string => `${getDateFormat()} ${getTimeFormat()}`;

export const AVAILABLE_LANGUAGES = [LANG_EN_SLUG, LANG_SK_SLUG];

// export const resolveLanguageFromLS = (): TLangSlug | null => {
//   const currentLang = getLangLocalStorage();
//   if (!currentLang) {
//     setLangLocalStorage(LANG_EN_SLUG);
//     return LANG_EN_SLUG;
//   }
//   return currentLang as TLangSlug;
// };

export const getLangFromUrl = (): TLangSlug | false => {
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('setLang');

  if (typeof langParam === 'string' && AVAILABLE_LANGUAGES.includes(langParam)) {
    return langParam as TLangSlug;
  }

  return false;
};

export const setLangLocalStorage = (language: TLangSlug) => {
  localStorage.setItem('CURRENT_LANGUAGE', language);
};

export const getLangLocalStorage = (): TLangSlug | null => {
  return localStorage.getItem('CURRENT_LANGUAGE') as TLangSlug;
};

export const copyToClipboard = (str: string) => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected =
    // @ts-ignore
    document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (selected) {
    // @ts-ignore
    document.getSelection().removeAllRanges();
    // @ts-ignore
    document.getSelection().addRange(selected);
  }
};

export const normalizeDiacritics = (word: string): string => {
  return word.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

/**
 * used to replace empty string values with null
 * @param obj
 */
export const nullify = (obj: any) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === '') {
      obj[key] = null;
    }
  });
};

export const removeDuplicates = (messages: TDirectMessage[]): TDirectMessage[] => {
  return (messages = messages.filter(
    (message, index, self) =>
      index === self.findIndex((m) => message.uuid === m.uuid && message.body === m.body),
  ));
};

export const groupMessagesByDate = (messages: TDirectMessage[] | TMessage[]) => {
  const date = (message: TDirectMessage) => moment(message.stamp).format('YYYY-MM-DD');

  const result = _(messages)
    .groupBy(date)
    .map((items, d) => ({
      date: d,
      messages: items,
    }))
    .value();

  return result;
};

//@ts-ignore
export const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
